module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/readable-stream/writable-browser.js
// module id = ../../../../readable-stream/writable-browser.js
// module chunks = common